@if (updateRegistrationError) {
  <ds-error-message [errorList]="errorList"></ds-error-message>
}
<h3
  dsContent
  [contentPath]="'billing.stopManagingHeading'"
  applicationDependentCopy="true"
  data-cy="stopManagingHeading"
></h3>
<p
  dsContent
  [contentPath]="'billing.stopManagingContent'"
  applicationDependentCopy="true"
  data-cy="stopManagingContent"
></p>
<h3
  class="are-you-sure"
  dsContent
  [contentPath]="'billing.stopManagingConfirm'"
  data-cy="stopManagingConfirm"
></h3>
@if (scheduledPaymentsToRemove.length) {
  <div class="margin-bottom-20">
    <p
      class="font-weight-bold"
      dsContent
      [contentPath]="'billing.stopManagingRemoveScheduled'"
      data-cy="stopManagingRemoveScheduled"
    ></p>
    <ds-bill-account-payments-scheduled
      class="block pad-bottom-20"
      [billAccountNumber]="billAccount.billAccountNumber"
      [tableOnly]="true"
    ></ds-bill-account-payments-scheduled>
  </div>
}
@if (automaticPaymentsToCancel.length) {
  <div class="margin-bottom-20">
    <p
      class="font-weight-bold"
      dsContent
      [contentPath]="'billing.stopManagingCancelAutomatic'"
      data-cy="stopManagingCancelAutomatic"
    ></p>
    <ds-auto-pay-detail-wrapper
      [billAccountNumber]="billAccount.billAccountNumber"
      [tableOnly]="true"
    ></ds-auto-pay-detail-wrapper>
  </div>
}
@if (deletePaymentMethods && paymentAccounts.length) {
  <div class="margin-bottom-20">
    <p
      class="font-weight-bold"
      dsContent
      [contentPath]="'billing.stopManagingDeleteMethods'"
      data-cy="stopManagingDeleteMethods"
    ></p>
    <ds-payment-methods [tableOnly]="true"></ds-payment-methods>
  </div>
}
@if (preferenceWillChange) {
  <div class="margin-bottom-20">
    <p
      class="font-weight-bold"
      dsContent
      [contentPath]="'billing.stopManagingUpdatePreferences'"
      data-cy="stopManagingUpdatePreferences"
    ></p>
    <p dsContent [contentPath]="'billing.stopManagingSetPaper'" data-cy="stopManagingSetPaper"></p>
  </div>
}
<button
  ds-button
  [dsAnalyticsClick]="stopManagingAnalytics.link"
  class="-error"
  (click)="stopManaging()"
  [attr.aria-label]="stopManagingBtnContent"
  data-cy="stopManagingAccount"
>
  {{ stopManagingBtnContent }}
</button>
